import { Box, Stack, Typography } from "@mui/material"
import { FCWC } from ".."
import { Container } from ".."

interface InfoSectionProps {
  title: string
  subtitle: string
}

const InfoSection: FCWC<InfoSectionProps> = ({ title, subtitle, children }) => {
  return (
    <Box
      sx={(theme) => ({
        padding: { xs: theme.spacing(12, 6), md: theme.spacing(24, 10) },
        borderTop: "1px solid rgba(243, 234, 210, 0.10)",
      })}
    >
      <Container maxWidth={1400} padding={`0!important`}>
        <Box
          display="grid"
          gridTemplateColumns={{ xs: "1fr", md: "repeat(2, 1fr)" }}
          justifyContent={{ xs: "flex-start", md: "space-between" }}
          gap={{ xs: 6, md: 2 }}
        >
          <Stack gap={3}>
            <Typography
              variant="heading.md"
              sx={{
                fontSize: "40px!important",
                color: (theme) => theme.palette["tertiary.800"].main,
                lineHeight: "90%",
                maxWidth: { xs: "100%", md: "400px" },
              }}
            >
              {title}
            </Typography>
            <Typography
              variant="heading.sm"
              sx={{
                color: (theme) => theme.palette["primary.800"].main,
                lineHeight: "110%",
                fontSize: "24px!important",
                fontWeight: 600,
                letterSpacing: "-0.288px",
                maxWidth: { xs: "100%", md: "300px" },
              }}
            >
              {subtitle}
            </Typography>
          </Stack>
          {children}
        </Box>
      </Container>
    </Box>
  )
}

export default InfoSection
